import { useTranslation } from 'react-i18next';
import { selectedRoadSectionsQuery } from '../../../../../core/reference/queries';
import { useAppDispatch, useAppSelector } from '../../../../../types';
import { useEffect, useState } from 'react';
import { ContentContainer, ModalTitle } from '../../../../legacy/components/ui/modals/styles';
import GenericModal from '../../../../legacy/components/ui/modals/GenericModal';
import { ReferenceModalTypes } from '../../../../../core/legacy/reducers/modals';
import { Input } from '../../../../session/list-sessions/styles';
import editRoadSections from '../../../../../core/reference/commands/EditRoadSections';

const EditRoadSectionCategoryModal = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const checkedRoadSections = useAppSelector(selectedRoadSectionsQuery);
    const checkedRoadSectionsIds = checkedRoadSections.map((s) => s.id);

    const [category, setCategory] = useState('');

    useEffect(() => {
        const categories = checkedRoadSections
            .map((rs) => rs.category)
            .filter((n) => n !== undefined)
            .reduce((acc, val) => acc.add(val!), new Set<string>());
        if (categories.size === 1) {
            setCategory(categories.values().next().value as string);
        } else {
            setCategory('');
        }
    }, [checkedRoadSections]);

    const onValidate = () => {
        dispatch(
            editRoadSections({
                roadSectionData: {
                    category,
                },
                roadSectionIds: checkedRoadSectionsIds,
            }),
        );
        setCategory('');
    };

    const handleKeyDown = ({ key }: KeyboardEvent) => {
        if (key === 'Enter') {
            onValidate();
        }
    };

    return (
        <GenericModal
            onValidate={onValidate}
            modalType={ReferenceModalTypes.ROAD_SECTION_EDIT_CATEGORY}
            options={{ notDismissableByClickingOnBackground: true }}
        >
            <ContentContainer>
                <ModalTitle>{t('reference.modals.editCategory')}</ModalTitle>
                <Input
                    onKeyDown={handleKeyDown}
                    value={category}
                    type="text"
                    onChange={(e) => setCategory(e.target.value)}
                    autoFocus
                />
            </ContentContainer>
        </GenericModal>
    );
};

export default EditRoadSectionCategoryModal;
